<template>
    <div class="main">
        <div id="screen" class="screen"></div>
    </div>
</template>

<script>
import ZThree from "@/three/ZThree";
import * as THREE from "three";
import { loaderModel } from "@/three/loaderModel";
import { CSS3DRenderer, CSS3DSprite, CSS3DObject } from "three/examples/jsm/renderers/CSS3DRenderer.js";

let app, camera, scene, renderer, css3Renderer, controls, clock;
export default {
    name: "HomeView",
    components: {},
    mounted() {
        this.initZThree();
    },
    methods: {
        async initZThree() {
            app = new ZThree("screen");
            app.initThree();
            // app.initHelper();
            app.initOrbitControls();
            app.initLight();
            clock = new THREE.Clock();

            controls = app.controls;
            camera = app.camera;
            scene = app.scene;
            renderer = app.renderer;
            css3Renderer = app.css3Renderer;
            console.log(app);

            const testDiv = document.createElement("div");
            testDiv.innerHTML = "演示标签";
            testDiv.style.background = "black";
            testDiv.style.color = "white";

            const css3Object = new CSS3DSprite(testDiv);
            //            const css3Object = new CSS3DObject(testDiv);

            css3Object.scale.set(0.1, 0.1, 0.1);
            css3Object.position.set(10, 10, 10);
            scene.add(css3Object);

            // 创建指向线的几何体
            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute("position", new THREE.BufferAttribute(new Float32Array([5, 3, 5, 10, 10, 10]), 3));

            // 创建指向线的材质
            const material = new THREE.LineBasicMaterial({
                color: "#ff0000", // 指定线的颜色
                linewidth: 5, // 设置线的宽度
            });
            // 创建指向线对象
            const line = new THREE.Line(geometry, material);

            scene.add(line);

            await loaderModel(app);

            // const geometry = new THREE.BoxGeometry(5, 5, 5);
            // const material = new THREE.MeshStandardMaterial({ color: 0x00ff00 });
            // const cube = new THREE.Mesh(geometry, material);
            // scene.add(cube);

            app.render(() => {
                const delta = clock.getDelta();
                controls.update(delta);
                renderer.render(scene, camera);
                css3Renderer.render(scene, camera);
            });
        },
    },
};
</script>

<style lang="less">
.main {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.screen {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #000;
}
</style>